
import { createStyles, makeStyles } from "@material-ui/core";


export const useCalendarStyle = makeStyles((theme) =>
  createStyles({
    cell: {
      height: 150,
      color: "#78909C!important",
      position: "relative",
      userSelect: "none",
      verticalAlign: "top",
      padding: 0,

      "&>div": {
        textAlign: "left",
        marginTop: 10,
        marginBottom: 20,
      },
      border: "1px solid #e0e0e0",
      "&:first-child": {
        borderLeft: "none",
      },
      "&:last-child": {
        paddingRight: 0,
      },
      "tr:last-child &": {
        borderBottom: "none",
      },
      "&:focus": {
        outline: 0,
      },
    },
    toDayCell: {
      backgroundColor: "#129ebf",
      "&>div": {
        textAlign: "left",
        color: "white",
        fontWeight: "bold",
      },
    },
    otherDayCell: {
      opacity: 0.4,
      "&>div": {
        color: "#129ebf",
        fontWeight: "bold",
      },
    },
    root: {
      width: "80%",
      display: "block",
      margin: "auto",
      marginTop: 100,
      backgroundColor: "transparent",
      "& #confetti": {
        position: "absolute",
        top: 0,
        left: "-50px",
      },
    },
    dayScaleLayout: {
      color: "#38c0ea",
      backgroundColor: " rgba(18, 158, 191, 0.19)",
    },
    oldDate: {
      backgroundColor: "white",
      "&>div": {
        textAlign: "left",
        fontSize: 12,
        color: "#78909C!important",
        fontWeight: "lighter",
        marginTop: 20,
        marginLeft: -10,
      },
    },
    dayScaleCell: {
      backgroundColor: " rgba(18, 158, 191, 0.19)",
      borderColor: " rgba(18, 158, 191, 0.0)",
      "&>div": {
        color: "#38c0ea",
        fontWeight: "bolder",
        fontSize: 15,
        textTransform: "uppercase",
      },
    },
    monthViewLayout: {
      backgroundColor: "transparent",
      margin: 0,
    },
    timeTableCell: {
      "&>div": {
        color: "#757a93",
        fontWeight: "bolder",
        fontSize: 17,
        textAlign: "left",
      },
    },
    imageGift: {
      display: "block",
      margin: "auto",
      objectFit: "contain",
    },
  })
);
